export default __webpack_public_path__ + "static/media/mobilebanner3.27856c81.png";